import React, { useEffect } from 'react';
import { Col, Card, Row, Button, Container } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import { partial } from '../../../util/translation/translation';
import renderField from '../../../shared/components/custom/Field';
import validate from './validateQuestionaireCategoryForm';
import renderDropZoneField from '../../../shared/components/form/DropZoneMS';
import { getImageHash } from '../../../util/functions';
import TextEditor2 from '../../../shared/components/text-editor/TextEditor2';

const s = partial('shared');

const QuestionaireCategoryForm = ({
  isEdit,
  handleSubmit,
  questionaireCategory,
  initialize,
}) => {
  useEffect(() => {
    if (questionaireCategory) {
      const { title, description, imageUrl } = questionaireCategory;

      initialize({
        title,
        description,
        headingImage: imageUrl
          ? {
              name: 'questionaire image',
              preview: imageUrl,
              croppedImage: imageUrl,
              hash: getImageHash(imageUrl),
            }
          : undefined,
      });
    }
  }, [questionaireCategory]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <Container>
        <Row>
          <Col lg={6}>
            <div
              style={{
                backgroundColor: '#F4F4F6',
                borderRadius: 4,
                borderColor: '#D7DAE0',
                borderStyle: 'solid',
                borderWidth: 1,
                marginBottom: 10,
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottomWidth: 1,
                  borderBottomStyle: 'dashed',
                  borderColor: '#D7DAE0',
                  padding: '10px 10px 10px 10px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      lineHeight: '24px',
                      color: 'black',
                      fontWeight: 'bold',
                    }}
                  >
                    {s('details')}
                  </div>
                </div>
              </div>
              <div style={{ padding: '10px' }}>
                <Container>
                  <Row>
                    <Col>
                      <div className="form__form-group">
                        <span className="form-header">{s('title')}</span>
                        <div className="marginTop-5" />
                        <Field
                          name="title"
                          component={renderField}
                          placeholder={s('title')}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form__form-group">
                        <span className="form-header">{s('description')}*</span>
                        <Field
                          name="description"
                          component={TextEditor2}
                          header={[2, 3, false]}
                          placeholder={s('description')}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} style={{ marginTop: '15px' }}>
                      <Button type="submit" color="primary">
                        {isEdit ? s('update') : s('create')}
                      </Button>
                      <Link className="color-unset" to="/questionnaires?tab=3">
                        <Button type="button">{s('close')}</Button>
                      </Link>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div
              style={{
                backgroundColor: '#F4F4F6',
                borderRadius: 4,
                borderColor: '#D7DAE0',
                borderStyle: 'solid',
                borderWidth: 1,
                marginBottom: 10,
                width: '100%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottomWidth: 1,
                  borderBottomStyle: 'dashed',
                  borderColor: '#D7DAE0',
                  padding: '10px 10px 10px 10px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      fontSize: 16,
                      lineHeight: '24px',
                      color: 'black',
                      fontWeight: 'bold',
                    }}
                  >
                    {s('image')}
                  </div>
                </div>
              </div>
              <div style={{ padding: '10px' }}>
                <div className="form__form-group">
                  <Field
                    saveBase64Cropped
                    name="headingImage"
                    maxSize={3}
                    component={renderDropZoneField}
                    displayCrop
                    crop="BANNER_CROP"
                  />
                  <span className="form-header">
                    <strong>{s('note')}:</strong> {s('recommendedImageSize')}{' '}
                    16:9 (1035 x 582 px)
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </form>
  );
};
const reduxF = reduxForm({
  form: 'questionaire-category-form',
  validate,
});

export default reduxF(QuestionaireCategoryForm);
